import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from 'shared';

@Component({
    selector: 'confirm-dbwarning-dialog',
    templateUrl: './confirm-dbwarning-dialog.component.html',
    styleUrls: ['./confirm-dbwarning-dialog.component.css'],
    standalone: false
})
export class ConfirmDbwarningDialogComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<ConfirmDbwarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
 
  confirm() {
    this.dialogRef.close();
  }
}
